// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!

=========================================================
* Black Dashboard React v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
.tim-row {
  margin-bottom: 20px;
}

.tim-white-buttons {
  background-color: #777777;
}

.typography-line {
  padding-left: 25%;
  margin-bottom: 35px;
  position: relative;
  display: block;
  width: 100%;
}

.typography-line span {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  position: absolute;
  width: 260px;
  text-transform: none;
}

.tim-row {
  padding-top: 60px;
}

.tim-row h3 {
  margin-top: 0;
}

.offline-doc .page-header {
  display: flex;
  align-items: center;
}

.offline-doc .footer {
  position: absolute;
  width: 100%;
  background: transparent;
  bottom: 0;
  color: #fff;
  z-index: 1;
  padding-left: 0;
}

@media all and (min-width: 992px) {
  .sidebar .nav>li.active-pro {
    position: absolute;
    width: 100%;
    bottom: 10px;
  }
}

.card.card-upgrade .card-category {
  max-width: 530px;
  margin: 0 auto;
}

.offline-doc .page-header {
  min-height: 100vh;
  max-height: 999px;
  padding: 0;
  color: #ffffff;
  position: relative; }
  .offline-doc .page-header .page-header-image {
    position: absolute;
    background-size: cover;
    background-position: center center;
    width: 100%;
    height: 100%;
    z-index: -1; }
  .offline-doc .page-header .content-center {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;
    transform: translate(-50%, -50%);
    text-align: center;
    color: #FFFFFF;
    padding: 0 15px;
    width: 100%;
    max-width: 880px; }
  .offline-doc .page-header footer {
    position: absolute;
    bottom: 0;
    width: 100%; }
  .offline-doc .page-header .container {
    height: 100%;
    z-index: 1; }
  .offline-doc .page-header .category,
  .offline-doc .page-header .description {
    color: rgba(255, 255, 255, 0.8); }
  .offline-doc .page-header.page-header-small {
    min-height: 60vh;
    max-height: 440px; }
  .offline-doc .page-header.page-header-mini {
    min-height: 40vh;
    max-height: 340px; }
  .offline-doc .page-header .title {
    margin-bottom: 15px; }
  .offline-doc .page-header .title + h4 {
    margin-top: 10px; }
  .offline-doc .page-header:after, .offline-doc .page-header:before {
    position: absolute;
    z-index: 0;
    width: 100%;
    height: 100%;
    display: block;
    left: 0;
    top: 0;
    content: ""; }
  .offline-doc .page-header:before {
    background-color: rgba(0, 0, 0, 0.8); }

    .full-page>.content {
      padding-bottom: 150px;
      padding-top: 150px;
  }`, "",{"version":3,"sources":["webpack://./src/assets/demo/demo.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;CAgBC;AACD;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,OAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,kBAAkB,EAAE;EACpB;IACE,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,WAAW,EAAE;EACf;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IAGV,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,WAAW;IACX,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW,EAAE;EACf;IACE,YAAY;IACZ,UAAU,EAAE;EACd;;IAEE,+BAA+B,EAAE;EACnC;IACE,gBAAgB;IAChB,iBAAiB,EAAE;EACrB;IACE,gBAAgB;IAChB,iBAAiB,EAAE;EACrB;IACE,mBAAmB,EAAE;EACvB;IACE,gBAAgB,EAAE;EACpB;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,cAAc;IACd,OAAO;IACP,MAAM;IACN,WAAW,EAAE;EACf;IACE,oCAAoC,EAAE;;IAEtC;MACE,qBAAqB;MACrB,kBAAkB;EACtB","sourcesContent":["/*!\r\n\r\n=========================================================\r\n* Black Dashboard React v1.1.0\r\n=========================================================\r\n\r\n* Product Page: https://www.creative-tim.com/product/black-dashboard-react\r\n* Copyright 2020 Creative Tim (https://www.creative-tim.com)\r\n* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)\r\n\r\n* Coded by Creative Tim\r\n\r\n=========================================================\r\n\r\n* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\r\n\r\n*/\r\n.tim-row {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.tim-white-buttons {\r\n  background-color: #777777;\r\n}\r\n\r\n.typography-line {\r\n  padding-left: 25%;\r\n  margin-bottom: 35px;\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.typography-line span {\r\n  bottom: 10px;\r\n  color: #c0c1c2;\r\n  display: block;\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  line-height: 13px;\r\n  left: 0;\r\n  position: absolute;\r\n  width: 260px;\r\n  text-transform: none;\r\n}\r\n\r\n.tim-row {\r\n  padding-top: 60px;\r\n}\r\n\r\n.tim-row h3 {\r\n  margin-top: 0;\r\n}\r\n\r\n.offline-doc .page-header {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.offline-doc .footer {\r\n  position: absolute;\r\n  width: 100%;\r\n  background: transparent;\r\n  bottom: 0;\r\n  color: #fff;\r\n  z-index: 1;\r\n  padding-left: 0;\r\n}\r\n\r\n@media all and (min-width: 992px) {\r\n  .sidebar .nav>li.active-pro {\r\n    position: absolute;\r\n    width: 100%;\r\n    bottom: 10px;\r\n  }\r\n}\r\n\r\n.card.card-upgrade .card-category {\r\n  max-width: 530px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.offline-doc .page-header {\r\n  min-height: 100vh;\r\n  max-height: 999px;\r\n  padding: 0;\r\n  color: #ffffff;\r\n  position: relative; }\r\n  .offline-doc .page-header .page-header-image {\r\n    position: absolute;\r\n    background-size: cover;\r\n    background-position: center center;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: -1; }\r\n  .offline-doc .page-header .content-center {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    z-index: 2;\r\n    -ms-transform: translate(-50%, -50%);\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    text-align: center;\r\n    color: #FFFFFF;\r\n    padding: 0 15px;\r\n    width: 100%;\r\n    max-width: 880px; }\r\n  .offline-doc .page-header footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%; }\r\n  .offline-doc .page-header .container {\r\n    height: 100%;\r\n    z-index: 1; }\r\n  .offline-doc .page-header .category,\r\n  .offline-doc .page-header .description {\r\n    color: rgba(255, 255, 255, 0.8); }\r\n  .offline-doc .page-header.page-header-small {\r\n    min-height: 60vh;\r\n    max-height: 440px; }\r\n  .offline-doc .page-header.page-header-mini {\r\n    min-height: 40vh;\r\n    max-height: 340px; }\r\n  .offline-doc .page-header .title {\r\n    margin-bottom: 15px; }\r\n  .offline-doc .page-header .title + h4 {\r\n    margin-top: 10px; }\r\n  .offline-doc .page-header:after, .offline-doc .page-header:before {\r\n    position: absolute;\r\n    z-index: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    left: 0;\r\n    top: 0;\r\n    content: \"\"; }\r\n  .offline-doc .page-header:before {\r\n    background-color: rgba(0, 0, 0, 0.8); }\r\n\r\n    .full-page>.content {\r\n      padding-bottom: 150px;\r\n      padding-top: 150px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
